import { useState, useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'
import SpeczeLogo from '../../assets/SpeczeLogo'

const navItems = [
  { label: 'Product',   href: '#features' },
  { label: 'Solutions', href: '#solutions' },
  { label: 'Pricing',   href: '#pricing' },
  { label: 'Docs',      href: '#docs' },
  { label: 'Blog',      href: '#blog' },
]

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false)
  const [open, setOpen]         = useState(false)
  const { user } = useAuth()
  const navigate = useNavigate()

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20)
    window.addEventListener('scroll', onScroll)
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      scrolled ? 'bg-cosmic-900/90 backdrop-blur-xl border-b border-white/8 shadow-lg' : 'bg-transparent'
    }`}>
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        {/* Logo */}
        <Link to="/" className="flex-shrink-0">
          <SpeczeLogo size={32} />
        </Link>

        {/* Desktop nav */}
        <div className="hidden md:flex items-center gap-6">
          {navItems.map(item => (
            <a key={item.label} href={item.href}
              className="nav-link text-sm font-medium text-white/70 hover:text-white transition-colors flex items-center gap-1">
              {item.label}
              <svg className="w-3 h-3 opacity-50" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7"/>
              </svg>
            </a>
          ))}
        </div>

        {/* Actions */}
        <div className="hidden md:flex items-center gap-3">
          {user ? (
            <Link to="/dashboard" className="btn-specze-md text-white">
              Go to Dashboard
            </Link>
          ) : (
            <>
              <Link to="/login" className="text-sm font-medium text-white/70 hover:text-white transition-colors px-3 py-2">
                Login
              </Link>
              <Link to="/register" className="btn-specze-md text-white">
                Start Free Trial
              </Link>
            </>
          )}
        </div>

        {/* Mobile hamburger */}
        <button className="md:hidden text-white/60 hover:text-white" onClick={() => setOpen(!open)}>
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            {open
              ? <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12"/>
              : <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16"/>
            }
          </svg>
        </button>
      </div>

      {/* Mobile menu */}
      {open && (
        <div className="md:hidden bg-cosmic-900/95 backdrop-blur-xl border-b border-white/8 px-6 py-4 space-y-3">
          {navItems.map(item => (
            <a key={item.label} href={item.href}
              className="block text-sm font-medium text-white/70 hover:text-white py-2"
              onClick={() => setOpen(false)}>
              {item.label}
            </a>
          ))}
          <div className="pt-2 flex flex-col gap-2">
            <Link to="/login"    className="btn-outline-md justify-center" onClick={() => setOpen(false)}>Login</Link>
            <Link to="/register" className="btn-specze-md justify-center text-white" onClick={() => setOpen(false)}>Start Free Trial</Link>
          </div>
        </div>
      )}
    </nav>
  )
}
